__turbopack_context__.v({
  "content": "BlockEventNearby-module-scss-module__SuMVtW__content",
  "copy": "BlockEventNearby-module-scss-module__SuMVtW__copy",
  "cta": "BlockEventNearby-module-scss-module__SuMVtW__cta",
  "headline": "BlockEventNearby-module-scss-module__SuMVtW__headline",
  "image": "BlockEventNearby-module-scss-module__SuMVtW__image",
  "inner": "BlockEventNearby-module-scss-module__SuMVtW__inner",
  "root": "BlockEventNearby-module-scss-module__SuMVtW__root",
});
